import React, { View, useEffect, useRef, KeyboardAvoidingView } from "react";
import { useState  } from 'react'
import Header from './HeaderMob';
import { useNavigate } from 'react-router-dom'
import LoginProcess from "./loginProcessMob";
import MetaMaskSDK from '@metamask/sdk';

import {loadStripe} from '@stripe/stripe-js';
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

new MetaMaskSDK({
    useDeeplink: false,
    communicationLayerPreference: "socket",
});



        
//const intentGW = process.env.REACT_APP_PAYMENTGATEWAY;
const intentGW = process.env.REACT_APP_GATEWAY

     const stripePromise = loadStripe(
      //"pk_live_51NsMC1J4lvUbSAbbUs7YOhEpv2CpVbPjkeklstm7GngjdPCWlJaQIsMgkXgNb6Gax9YAWR5CBsfeQr3dqZCV7tFq003AuPVZgW" // Live
      "pk_test_51SW1wtQrJEge4qHzQQ1iw9MG4CHgfn5zXITJhW511Lb3A8zZb2jfS93O9J8xRUkNtlgRfK2uBEOdZjPx8p2NsnpC00QUsvPgSg" // Sandbox
      
     );
    

function New() {
    const [Message, setMessage] = useState("");
    const [Info, setInfo] = useState(false);
    const [stage, setStage] = useState(0);
    const [priv, setPriv] = useState(0);
    const [sig, setSig] = useState({ signed: 0, sig: "" });
    const [serie, setSerie] = useState(0);
    const [coin, setCoin] = useState(0);
    const [userinfo, setUserinfo] = useState({ id: 0 });
    const [wallet, setWallet] = useState("");
    const [europe, setEurope] = useState(false);
    const [name, setName] = useState("");
    const [vat, setVat] = useState("");

    const TotalStages = 9;
    const navigate = useNavigate();
    const idea = useRef();

    const isEmpty = (str) => {
        return !str || !str.trim().length;
    };

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    
    function replaceAll(str, find, replace) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    }
    
    function correctphrase(str) {
        str = str.toLowerCase();
        str = replaceAll(str, " ", "_");
        str = replaceAll(str, '\n', "|");
        return str;
    }
    
    function getQueryVariable(variable)
    {
            var query = window.location.search.substring(1);
            const params = new URLSearchParams(window.location.search);
            var vars = query.split("&");
            //
            var out = "";
          
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] === variable) {
                    return pair[1];
                }
            }
                return out;
            
    }


    async function changeStage(dir) {
        //can I go forward?

        if (dir === -2) {
            dir = 0;
        } else {
                 //vasco
            if (stage === 0 && dir === 1) {
                var idea = document.getElementById('ideaTextArea');

                if (idea.value === "") {
                    setMessage("no empty ideas");
                    setInfo(true);
                    setTimeout(() => {
                        setInfo(false);
                        }, 1500);
                    return;
                } else {
                    setMessage("");
                }
            }
            var stage0 = document.getElementById('stage0');
            stage0.style.display = "none";
            if (stage === 2 && dir === 1) {
                if(sig.signed === 1 && sig.sig.replace(/\s/g, "") === "")
                var signature = document.getElementById('sig');
                if (signature) {
                    if (signature.value === "") {
                        setMessage("no empty signatures");
                        setInfo(true);
                        setTimeout(() => {
                            setInfo(false);
                            }, 1500);
                        return;
                    } else {
                        setMessage("");
                    }
                }
            }
            if (stage === 3 && dir === 1) {

                if (priv === 0) {
                    var price = document.getElementById('price')
                    if (price) {
                        if (price.value === "" ) {
                            setMessage("We need a price");
                            setInfo(true);
                            setTimeout(() => {
                                setInfo(false);
                                }, 1500);
                            return;
                        }else {
                            setMessage("");
                        }
                        if (!isNumber(price.value)) {
                            setMessage("We need a number");
                            setInfo(true);
                            setTimeout(() => {
                                setInfo(false);
                                }, 1500);
                            return;
                        }else {
                            setMessage("");
                        }


                    }
                }
            }
            if (stage === 6 && dir === 1) {
                if (isEmpty(name)) {
                    setMessage("We need a name");
                    setInfo(true);
                    setTimeout(() => {
                        setInfo(false);
                    }, 1500);
                    return;
                }

                if (europe) {
                    if (isEmpty(vat)) {
                        setMessage("We need a valid fiscal code");
                        setInfo(true);
                        setTimeout(() => {
                            setInfo(false);
                        }, 1500);
                        return;
                    }

                    // Validate VAT - backend expects full VAT string (e.g., PT515859737)
                    var trimmedVat = vat.trim();
                    try {
                        var result = await fetch(intentGW + "/vat/" + trimmedVat);
                        var data = await result.json();

                        if (!data.valid) {
                            setMessage("Invalid fiscal code");
                            setInfo(true);
                            setTimeout(() => {
                                setInfo(false);
                            }, 1500);
                            return;
                        }
                    } catch (error) {
                        setMessage("Error validating fiscal code");
                        setInfo(true);
                        setTimeout(() => {
                            setInfo(false);
                        }, 1500);
                        return;
                    }
                }
            }
            if (stage == 8) { 

                const options = {
                    amount: getTotal().total,
                    currency: 'eur',
                    mode: 'payment',
                    appearance: {
                        /*...*/
                    },
                };
        
                function getTotal() { 
                    //vasco
                    var value = 0;
                    if (serie === 0) value = process.env.REACT_APP_TIER0;
                    if (serie === 1) value = process.env.REACT_APP_TIER1;
                    if (serie === 2) value = process.env.REACT_APP_TIER2;
                    if (serie === 3) value = process.env.REACT_APP_TIER3;

                    var ideaCost = parseInt(value);
                    var mintCost ;
                    var total;
                    var label;
                    var walletType = wallet === process.env.REACT_APP_OWNWALLET;
        
                    if (walletType) {
                        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_HYP);
                        label = "Mint with HyperWallet"
                    } else { 
                        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_OWN);
                        label = "Mint with own wallet"
                    }
        
                    total = ideaCost + mintCost;
                    return {idea:ideaCost , mint: mintCost , total:total,label : label}
        
        
                }
                

            }

        }

        //hide all messages
        setInfo(false);
        setMessage("");

        var stages = document.querySelectorAll('.stages');

        stages.forEach(function (stage, index) {
            stage.style.display = "none";
        });
        
          //paypal
          if (getQueryVariable('payment_intent') && stage !== 8) {
              dir = 8;
          }

          if (stage === 3 && priv === 1) {
            dir = dir*2;
      }
        
        var nstage = stage + dir;
        var cStage = document.getElementById('stage' + nstage);
        cStage.style.display = "flex";

        if (stage => 0 && stage <= TotalStages) { 
            setStage(stage + dir)
        }
    }

    function checkNext() {

        //stage !== 6 && (wallet != "" && stage === 4)  && stage < TotalStages
        if (stage  === 0 ) return true;
        if (stage === 1) return true;
        if (stage === 2) return true;
        if (stage === 3) return true;
        if (stage === 4) return true;

        if (stage === 5 && wallet !== "") return true;
        if (stage === 6) return true;
        if (stage === 8) return false;
        return false;
    }

    function checkPrev() { 
 
        if (stage === 9) return false;
        if (stage > 0) return true;
        return false;
    }

    function Control({ stage }) { 
      return(
          <div className="buyfooter w-full absolute bottom-0">
                <div className="bleft pl-5">
                {checkPrev() > 0 ?
              
                  <span className="mouse2" onMouseDown={() => { changeStage(-1) }}>{"Prev"}</span>
                  : null
              }
              
                  </div>
              
                  <div className='bright pr-5'>
              
                  {checkNext() ?
                  <span className='mouse2' onMouseDown={() => { changeStage(1); }}> {"Next"} </span>
                  : null}
                  </div>
             
          </div>
     )    
    }

    function Messages(props) {

        return (
             
                <>
                <div className="messages text-black border-0 border-red-500">
                    <div className={props.Info ? "alert-show " : "AlertfadeOut "} {...props.Info ?  "hidden" : null }> {props.message} </div>
                </div>
                </>
                    
        )
    }
    
    function WalletConnectDivs({ serie,priv,handlePriceChange }) {
        
        function ownWallet() { 
            setWallet(process.env.REACT_APP_OWNWALLET);
        }

        function clearOwnWallet() { 
            setWallet("");
        }



        async function ConnectToWallet(setWallet,priv,serie,handlePriceChange) {
            

            if (typeof window.ethereum !== 'undefined') {
                // Do something
                window.ethereum.request({ method: 'eth_requestAccounts' })
                    .then(res => {
                        // Return the address of the wallet
                        setWallet(res[0]);
                        handlePriceChange(priv,serie,res[0]);
                    })
        
                window.ethereum.on('accountsChanged', handleAccountsChanged);
        
                function handleAccountsChanged(accounts) {
                    if (accounts.length === 0) {
                        setWallet("");
                        handlePriceChange(priv,serie,"");
                    }
                }
                function handAccountDisconnect() { 
                    setWallet("");
                    handlePriceChange(priv,serie,"");
                }
        
                window.ethereum.on('disconnect',handAccountDisconnect);
        
        
            } else {
                
            }
        }

      

        return (
            <div className="w-full flex flex-col align-middle justify-center text-black h-dvh"  >
                   {wallet === "" ?
                  <div className='w-full'>
                        <div className="w-full flex justify-center" onMouseDown={() => { ConnectToWallet(setWallet) }}>[ Your Wallet ]</div>
                        <div className="flex justify-center">or</div>
                        <div className="w-full flex justify-center" onMouseDown={() => { ownWallet() }}>[ HyperWallet ]</div>
                     </div>
                    :
                    
                        wallet === process.env.REACT_APP_OWNWALLET ? 
                            <div className='text-sm flex flex-col items-center w-full'>
                            You are connected to the Hyperwallet<br /><br />
                            ( that is our wallet where we hold your tokens on your behalf )<br /> <br />
                            <span onMouseDown={() => {
                            setWallet("");         
                    }}  className="mouse2 colorWallet" >Disconnect</span>
                            </div>
                            :
                            <div className='text-sm flex flex-col items-center w-full '>
                                <div>You are connected to your wallet </div>
                                <div>{wallet} </div> <div onMouseDown={() => {
                                if (sessionStorage.getItem("wallet") !== "") { 
                                    sessionStorage.removeItemItem("wallet")
                                    setWallet("");
                                 }
                        
                    }}  className="" >Disconnect</div>
                            </div>
                    
                
            }
            </div>

       
            )
        
    }

    useEffect(() => {
        changeStage(-2)
        var d = JSON.parse(sessionStorage.getItem("userinfo"));
        if (d != null && userinfo.id == 0) { 
            setUserinfo(d);
        }
    }, [])

    function close() {
        setInfo(false);
        navigate('/')
    }
    
    function isNumber(value) {
        var regex = /^[0-9]+$/;
        return value.match(regex);
    }
    
    const handleSave = event => {
        var value = 0;
        if (serie === 0) value = process.env.REACT_APP_TIER0;
        if (serie === 1) value = process.env.REACT_APP_TIER1;
        if (serie === 2) value = process.env.REACT_APP_TIER2;
        if (serie === 3) value = process.env.REACT_APP_TIER3;
        var Ccurrency = "";
        if (coin === 0) Ccurrency = "eur";
        if (coin === 1) Ccurrency = "usd";
        var wwprice = 0;
        if (wallet === process.env.REACT_APP_OWNWALLET) {
            wwprice = 4000;
        } else { 
            wwprice = 2000;
        }


        fetch(`${process.env.REACT_APP_EXCHANGE}`)
        .then(currency => {
            return (currency.json());
        }).then(displayResults);

        function displayResults(currency) { 
            
            if (coin === 0) { 
                value = value * currency.rates["EUR"];
                wwprice = wwprice * currency.rates["EUR"];
            }
    
    
    
       
            changeStage(1);
        }

        
    };

    function afterLogin() {
        setTimeout(function () {
            setUserinfo(JSON.parse(sessionStorage.getItem("userinfo")));
        },2000);
    }


    const CheckoutForm = (props) => {
        const stripe = useStripe();
        const elements = useElements();



        const [errorMessage, setErrorMessage] = useState(null);
        const [Loading, setLoading] = useState(0);
        const [isProcessing, setIsProcessing] = useState(false);

        const handleSubmit = async (event) => {
          //event.preventDefault();

            // Prevent multiple submissions
            if (isProcessing) {
                return;
            }

            setIsProcessing(true);
            setLoading(1);

          if (elements == null) {
            setLoading(0);
            setIsProcessing(false);
            return;
          }

          if (stripe == null) {
            setLoading(0);
            setIsProcessing(false);
            return;
          }

          // Trigger form validation and wallet collection
          const {error: submitError} = await elements.submit();
          if (submitError) {
            // Show error to your customer
            setErrorMessage(submitError.message);
            setLoading(0);
            setIsProcessing(false);
            return;
          }

          // Get the payment element to check if it's complete
          const paymentElement = elements.getElement('payment');
          if (!paymentElement) {
            setErrorMessage("Payment element not ready");
            setLoading(0);
            setIsProcessing(false);
            return;
          }
            
          elements.on('ready', () => {
            
        })
            
      
            
                var value = 0;
                if (serie === 0) value = process.env.REACT_APP_TIER0;
                if (serie === 1) value = process.env.REACT_APP_TIER1;
                if (serie === 2) value = process.env.REACT_APP_TIER2;
                if (serie === 3) value = process.env.REACT_APP_TIER3;
                var Ccurrency = "EUR";
                var wwprice = 0;
                if (wallet === process.env.REACT_APP_OWNWALLET) {
                    wwprice = 4000;
                } else { 
                    wwprice = 2000;
                }



            // Calculate tax if European
            var subtotal = parseInt(value) + wwprice;
            var tax = 0;
            var totalAmount = subtotal;

            if (europe) {
                tax = Math.round(subtotal * 0.22);
                totalAmount = subtotal + tax;
            }

            var ddata = {
                price:value,
                phrase: correctphrase(document.getElementById('ideaTextArea').value),
                sig:document.getElementById('sig') ? document.getElementById('sig').value  : "",
                wallet:wallet,
                type:serie,
                priv:priv,
                currency:Ccurrency,
                Wprice:wwprice,
                sprice: document.getElementById('price') ? document.getElementById('price').value*100 : 0 ,
                HWallet:wallet === process.env.REACT_APP_OWNWALLET ? true : false,
                userId:userinfo.id,
                name: name,
                vat: vat,
                europe: europe,
                tax: tax,
                subtotal: subtotal,
                totalAmount: totalAmount
            }

            

            try {
                const response = await fetch(intentGW+ "/create-intent", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({data:ddata, token:userinfo.token }),
                });

                if (!response.ok) {
                    throw new Error("Failed to create payment intent");
                }

                const data = await response.json();
                const clientSecret = data.clientSecret;

                const { error, paymentIntent } = await stripe.confirmPayment({
                    //`Elements` instance that was used to create the Payment Element
                    clientSecret,
                    elements,
                     confirmParams: {
                         return_url: "https://hyperuranium.io/new",
                          payment_method_data: {
                            billing_details: {
                            name: props.customerName || 'Customer',
                            address: {
                                line1: 'N/A',
                                city: 'N/A',
                                country: 'IT',
                                state: 'N/A',
                                postal_code: '00000',
                            }
                            }
                        }
                },
                redirect: "if_required",
                });

                if (error) {
                    // This point will only be reached if there is an immediate error when
                    // confirming the payment. Show error to your customer (for example, payment
                    // details incomplete)
                    setErrorMessage(error.message);
                    setTimeout(() => {
                        setErrorMessage("");
                    }, 3000);
                    setLoading(0);
                    setIsProcessing(false);
                } else {
                    // Your customer will be redirected to your `return_url`. For some payment
                    // methods like iDEAL, your customer will be redirected to an intermediate
                    // site first to authorize the payment, then redirected to the `return_url`.
                    setErrorMessage("Paid!");
                    setTimeout(() => {
                        changeStage(1);
                    }, 1000);
                }
            } catch (error) {
                setErrorMessage("Payment failed: " + error.message);
                setTimeout(() => {
                    setErrorMessage("");
                }, 3000);
                setLoading(0);
                setIsProcessing(false);
            }
      
            
         
        };

        

      
      const paymentElementOptions = {
      layout: 'tabs'
    };

         //vasco
        return (
            <>
          <form >
             <PaymentElement options={paymentElementOptions} />
            {/* Show error message to your customers */}
            
              <div className="text-red-500 text-sm mt-2 text-center h-10">
                 { errorMessage }
              </div>
                </form>

                {!Loading  ?
                    <span className='text-black w-full flex justify-center text-2xl p-0 border-0 pt-3 ' onClick={(e) => handleSubmit()}>[ Pay { euro.format(props.total / 100) }  ]</span>
                    :
                <span className='mouse2 text-black w-full flex justify-center text-2xl p-0 border-0 pt-3 '> [ Please wait  ]</span>

            }
            </>
        );
    };
    
    let euro = Intl.NumberFormat('en-DE', {
        style: 'currency',
        currency: 'EUR',
    });



    function Stage7(props) {

        const [totals, setTotals] = useState(getTotal);

        useEffect(() => { 
           
        }, [])

        


        const options = {
            amount: getTotal().total,
            currency:  'eur',
            mode: 'payment',
            appearance: {
                /*...*/
            },
        };

        function getTotal() {
            var value = 0;
            if (serie === 0) value = process.env.REACT_APP_TIER0;
            if (serie === 1) value = process.env.REACT_APP_TIER1;
            if (serie === 2) value = process.env.REACT_APP_TIER2;
            if (serie === 3) value = process.env.REACT_APP_TIER3;


            var ideaCost = parseInt(value);
            var mintCost ;
            var total;
            var label;
            var walletType = wallet === process.env.REACT_APP_OWNWALLET;
            var tax = 0;
            var subtotal;

            if (walletType) {
                mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_HYP);
                label = "Mint with HyperWallet"
            } else {
                mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_OWN);
                label = "Mint with own wallet"
            }

            subtotal = ideaCost + mintCost;

            // Add Italian VAT (22%) for European users
            if (europe) {
                tax = Math.round(subtotal * 0.22);
            }

            total = subtotal + tax;
            return {idea:ideaCost , mint: mintCost , subtotal: subtotal, tax: tax, total:total,label : label}


        }
        
        useEffect(() => {
              
          }, [idea]);
      
          
        return (
            <>
            <Elements stripe={stripePromise} options={options}>
                <div className='text-sm  w-full mb-10 top-1/5 absolute left-0 pl-10 pr-10 border-0 border-red-500'>
                    <table className="w-full">
                    <tbody className="border-0">
                        {totals.label !== "" ? (
                        <tr className="border-0">
                            <td className="border-0 text-left">{totals.label} : </td>
                            <td> {euro.format(totals.mint / 100)}</td>
                        </tr>
                        ) : null}
                        <tr>
                            <td>Idea : </td>
                            <td>{euro.format(totals.idea / 100)}</td>
                        </tr>
                        {totals.tax > 0 ? (
                            <>
                                <tr>
                                    <td>Subtotal : </td>
                                    <td>{euro.format(totals.subtotal / 100)}</td>
                                </tr>
                                <tr>
                                    <td>VAT (22%) : </td>
                                    <td>{euro.format(totals.tax / 100)}</td>
                                </tr>
                            </>
                        ) : null}
                        <tr>
                            <td>Total : </td>
                            <td>{euro.format(totals.total / 100)}</td>
                        </tr>
                        </tbody>
                </table>
                        <CheckoutForm total={getTotal().total} customerName={name} />
                    </div>
                    </Elements >
                        
             
                </>
          );
    }

    const open = url => {
        window.open(url, "_self");
    };

   
    
    
    return (
        <div className='w-full h-dvh flex-row '>
            <Messages message={Message} Info={Info} setInfo={setInfo} />
            <Header bg={1} destination="/about" />
          
           
            <Control stage={stage} />
            <div className="absolute top-10 pl-3 pr-3 w-full border-0 border-red-500 stages" id="stage0">
                  <textarea
                        ref={idea}
                        //maxLength="240" This is a really really bad idea
                        id="ideaTextArea"
                        autoFocus
                        onFocus={function(e) {
                            var val = e.target.value;
                            e.target.value = '';
                            e.target.value = val;
                        }}
                        onChange={e => idea.value = e.target.value}
                        placeholder="<please write your idea>"
                        className="border-0 w-full h-1"
                        style={{ minHeight: '60vh', fontSize: '18px' }}
                    />
                    
                </div>
            <div className="stages text-lg w-full absolute top-14 pl-2 pr-2" id="stage1" >
                
                [ You should only mint your original ideas. You can also mint ideas of others, duly attributing them to their author, only if they are no longer covered by copyright or, if they are, with the author’s express authorization. Failing this, your idea, while minted, will not be published. ]
                </div>
            <div className="stages text-lg w-full absolute top-1/3 pl-2 pr-2 " id="stage2">
                <div className="wouldYou ">
                    Would you like to:
                 
                        <div className="options ">
                        <div className={sig.signed ? "seriesOn" : "seriesOff"} onClick={() => { setSig({signed:1, sig:""}); }}>
                             Attribute the idea  
                        </div>
                        or
                        <div className={!sig.signed ? "seriesOn" : "seriesOff"} onClick={() => { setSig({signed:0, sig:""}); }}>
                            remain anonymous 
                            </div>
                    </div>
                    <div className="mt-10 w-full border-0 border-teal-500 h-fit flex">
                        {sig.signed ?   
                    <>
                            <input className="text-xl w-full" id="sig" placeholder='sign'  maxLength="40" autoFocus 
                            onFocus={function(e) {
                                e.target.placeholder = '';
                                }}
                            onChange={function(e) {
                                if (e.target.value === "") { 
                                    e.target.placeholder = 'Author';
                                }
                                }}
                            onBlur={function(e) {
                                if (e.target.value === "") { 
                                    e.target.placeholder = 'Author';
                                }
                            }}
                                />
                              </>
                                :
                                null    
                            }
                        </div>
                        </div> 
                 
            </div>
            <div className="stages" id="stage3">
                <div className="w-full border-0 border-teal-500  h-dvh items-center justify-center flex">
                    <div className="flex-row h-fit pl-5 pr-5  w-full">
                    <div className="inside text-xl " > Are you mintint it to : </div>
                        
                        <div className="options  text-xl">
                        <span className={priv ? "seriesOn" : "seriesOff"} onClick={() => { setPriv(1) }}>keep it to yourself</span>
                        <div className="justify-center ml-2 mr-10 align-middle ">or</div>
                        <span className={!priv ? "seriesOn" : "seriesOff"} onClick={() => { setPriv(0) }}> put it for sale</span>
                    </div>
                    
                    <div className="Moneydiv flex w-full border-0 border-amber-500">
                        {!priv ? 
                           <>
                            <div className=" ">
                                { /*check if format number ! */ }
                                <input
                                    className="text-xl"
                                    placeholder='price'
                                    id='price'
                                    maxLength="10"
                                    autoFocus
                                    type="text"
                                    inputMode="decimal"
                                    pattern="[0-9]*"
                                    onFocus={function(e) {
                                        e.target.placeholder = 'price';
                                    }}
                                    onChange={function(e) {
                                        if (e.target.value === "") {
                                            e.target.placeholder = 'price';
                                        }
                                    }}
                                    onBlur={function(e) {
                                        if (e.target.value === "") {
                                            e.target.placeholder = 'price';
                                        }
                                    }}
                                />
                                    </div>
                                <div className="seriesOff" >Euros</div>
                                
                                
                                </>
                            :
                                null
                        }
                       </div> 
                                
                    </div>  
                    </div>
            </div>
            <div className="stages" id="stage4">
            <span className=" w-full h-dvh text-2xl items-center border-teal-500 justify-center flex-row">
                            <div className=" pt-20 flex-row align-middle  h-dvh border-red-600">
                            <div className={serie === 0 ? "seriesOn w-full  justify-center flex" : "seriesOff justify-center flex w-full "} onClick={() => { setSerie(0) }} >[ unique ]</div>
                            <div className="justify-center flex" >OR EDITION :</div>
                            <div className={ serie === 1 ? "seriesOn w-full justify-center flex" : "seriesOff w-full justify-center flex"} onClick={() => { setSerie(1)}}>[ 1/10 ]</div>
                            <div className={ serie === 2 ? "seriesOn w-full justify-center flex" : "seriesOff w-full justify-center flex"} onClick={() => { setSerie(2)}}>[ 1/20 ]</div>
                            <div className={ serie === 3 ? "seriesOn w-full justify-center flex" : "seriesOff w-full justify-center flex"} onClick={() => { setSerie(3)}}>[ 1/100 ]</div >
                            </div>
                </span>     
            </div>
            <div className="stages" id="stage5">
                <WalletConnectDivs  />
            </div>
            <div className="stages text-lg w-full absolute top-1/4 pl-5 pr-5" id="stage6">
                <div className="flex-row text-center border-0">
                    <div className="flex mb-4">
                        <div className="w-1/2">Name:</div>
                        <div className="flex-1 text-sm">
                            <input
                                id="name"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                    setInfo(false);
                                    setMessage("");
                                }}
                                className="text-xl w-full"
                            />
                        </div>
                    </div>

                    <div className="flex mb-4">
                        <div className="w-1/2">Europe based?:</div>
                        <div className="flex-1">
                            <input
                                type="checkbox"
                                onChange={() => setEurope(!europe)}
                                checked={europe ? "checked" : ""}
                            />
                        </div>
                    </div>

                    {europe ? (
                        <div className="flex mb-4">
                            <div className="w-1/2">Fiscal Code:</div>
                            <div className="flex-1">
                                <input
                                    value={vat}
                                    onChange={(e) => {
                                        setVat(e.target.value);
                                        setInfo(false);
                                        setMessage("");
                                    }}
                                    className="text-xl w-full"
                                    id="vat"
                                    placeholder="<country Code><Number>"
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="stages" id="stage7">
                {userinfo.id === 0 ?
                    <div className="buyMain flex justify-center items-center w-full h-dvh text-black">
                <LoginProcess  callback={afterLogin}/>
                        </div>
                    :
                    <div className="border-0 w-full h-dvh items-center flex justify-center">
                    
                <span className="mouse selected" onClick={() => { handleSave() }} > [ MINT ]</span>
                    </div>
                }
            </div>
            <div className="stages " id="stage8">

                {stage === 8 ?
                    <div className="w-full border-0 h-dvh flex border-red-600 pt-10 justify-center items-center ">
                    <Stage7 />
                    </div>
                    :
                    null
                }

            </div>
            <div className="stages" id="stage9">
                <div className="paidThanks h-dvh text-xl flex items-center"  onTouchStart={(e) => { e.preventDefault(); navigate("/"); }}>
                    <div>
                    Thanks for minting your idea on hyperuranium,  <br />
                    your idea is now going throught the hyperuranium  <br />
                    aproval process, before being published  <br />
                </div>
            </div>
            </div>
            
        </div>
        
        )
}


export default New;

